import { render, staticRenderFns } from "./PendingAmountRow.vue?vue&type=template&id=71e781d7&scoped=true"
import script from "./PendingAmountRow.vue?vue&type=script&lang=ts"
export * from "./PendingAmountRow.vue?vue&type=script&lang=ts"
import style0 from "./PendingAmountRow.vue?vue&type=style&index=0&id=71e781d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e781d7",
  null
  
)

export default component.exports